import { render, staticRenderFns } from "./LookDetails.vue?vue&type=template&id=83af26fc&scoped=true"
import script from "./LookDetails.vue?vue&type=script&lang=js"
export * from "./LookDetails.vue?vue&type=script&lang=js"
import style0 from "./LookDetails.vue?vue&type=style&index=0&id=83af26fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83af26fc",
  null
  
)

export default component.exports